import { render } from "./online_bank_statement.html?vue&type=template&id=a055f0ec&external"
import script from "./online_bank_statement.js?vue&type=script&lang=js&external"
export * from "./online_bank_statement.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__